import { z } from 'zod/v3';
import { llmMessageSchema } from './llm';
import { Parser } from '@cotera/era';
import {
  ToolSymbolMapSchema,
  PartialUddWriteKeySchema,
} from './workflow-program-sink-config-types';

// This file is super slow to typecheck, so we special case it to JS to avoid
// editor slow downs

export const SinkConfigSchema = z.discriminatedUnion('t', [
  z.object({
    t: z.enum([
      'noop',
      'writeToLog',
      'klaviyoUpdateUsers',
      'kustomerAddNoteToConversation',
    ]),
    config: z.object({}),
  }),
  z.object({
    t: z.literal('workflowProgram'),
    config: z.object({
      program: z.string(),
      toolSymbolMap: ToolSymbolMapSchema,
      relIdentity: z.tuple([z.number(), z.number()]),
      colIdentity: z.tuple([z.number(), z.number()]),
      partialUddWriteKey: PartialUddWriteKeySchema,
    }),
  }),
  z.object({
    t: z.literal('klaviyoSendEvent'),
    config: z.object({ event: z.string() }),
  }),
  z.object({
    t: z.literal('brazeTrackUser'),
    config: z.object({
      brazeConnectionId: z.string(),
      endpoint: z.string().url(),
    }),
  }),
  z.object({
    t: z.literal('kustomerCreateObjects'),
    config: z.object({
      name: z.string(),
      fieldTypes: z.record(z.string(), z.enum(['txt', 'str'])),
    }),
  }),
  z.object({
    t: z.literal('llmCompletion'),
    config: z.object({
      model: z.string(),
      messages: llmMessageSchema.array(),
      expectedType: Parser.ExtendedAttributeTypeSchema,
      maxOutputTokens: z.number().optional(),
      durable: z.boolean().optional(),
      uddWriteKey: z.string().optional(),
      identity: z
        .object({
          rel: z.string(),
          col: z.string(),
        })
        .optional(),
      tools: z.array(z.string()).optional(),
      temperature: z.number().optional(),
      topP: z.number().optional(),
      topK: z.number().optional(),
      frequencyPenalty: z.number().optional(),
      presencePenalty: z.number().optional(),
    }),
  }),
  z.object({
    t: z.literal('coteraSlack'),
    config: z.object({
      channel: z.string(),
    }),
  }),
  z.object({
    t: z.literal('trueNutritionUpdateUser'),
    config: z.object({
      shopifyUrl: z.string(),
      shopifyConnectionId: z.string().optional(),
      klaviyoConnectionId: z.string().optional(),
    }),
  }),
]);
